/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `MRF` - Material recovery facility
* `PRF` - Plastic recovery facility
* `PL_RE` - Plastic reprocessor
* `MT_RE` - Metal reprocessor
* `P_MRF` - Paper MRF
* `PMILL` - Paper mill
* `PMERC` - Paper merchant
* `BROKE` - Broker
* `MT_YD` - Metal Yard
* `MT_SMELT` - Metal Smelter
* `OTHER` - Other
* `EXCLUSIVE_REPRESENTATIVE` - Exclusive Representative
 */
export type CompanyTypeEnum = typeof CompanyTypeEnum[keyof typeof CompanyTypeEnum];


export const CompanyTypeEnum = {
  MRF: 'MRF',
  PRF: 'PRF',
  PL_RE: 'PL_RE',
  MT_RE: 'MT_RE',
  P_MRF: 'P_MRF',
  PMILL: 'PMILL',
  PMERC: 'PMERC',
  BROKE: 'BROKE',
  MT_YD: 'MT_YD',
  MT_SMELT: 'MT_SMELT',
  OTHER: 'OTHER',
  EXCLUSIVE_REPRESENTATIVE: 'EXCLUSIVE_REPRESENTATIVE',
} as const;
